/* SCENTREAT candle warmer lamp page (04/11/2026) - behaviour of the approved L1–L3 preview (pdp-L1/build.py), on real variants.
 * Gallery thumbs, colour cards with − / + steppers, summary line ("Buy 2, save 10%" display only: the automatic discount does
 * the real maths in the cart), and ONE /cart/add.js call with every picked variant. The cart drawer opens through the theme's
 * own CartLinesUpdateEvent contract (same as assets/st-v4-col.js / product-form.js); no drawer -> /cart.
 */
(function () {
  const root = document.getElementById('pdp');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  /* ---- gallery ---- */
  const main = document.getElementById('pdpMain');
  const thumbs = [...root.querySelectorAll('.thumbs img')];
  const go = (i) => {
    const t = thumbs[i];
    if (!t || !main) return;
    main.src = t.dataset.full;
    main.srcset = t.dataset.srcset || '';
    main.alt = t.alt;
    thumbs.forEach((x, j) => x.classList.toggle('act', j === i));
  };
  thumbs.forEach((x, i) => x.addEventListener('click', () => go(i)));
  const goMedia = (mid) => { const i = thumbs.findIndex((t) => t.dataset.mid === mid); if (i > -1) go(i); };

  /* ---- buy box ---- */
  const cards = [...root.querySelectorAll('.qc')];
  const q = cards.map((c) => +c.dataset.q || 0);
  const per = +root.dataset.bulbs || 3;
  const cur = root.dataset.currency || 'USD';
  const lang = document.documentElement.lang || 'en';
  const money = (cents) => {
    const v = Math.round(cents) / 100;
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); } catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  };
  const sumEl = root.querySelector('[data-sum]');
  const offEl = root.querySelector('[data-off]');
  const atc = root.querySelector('[data-atc]');
  const barB = root.querySelector('.bar b');
  const msg = root.querySelector('[data-msg]');

  function upd() {
    const n = q.reduce((a, b) => a + b, 0);
    let full = 0;
    const picked = [];
    cards.forEach((cd, k) => {
      cd.querySelector('.step b').textContent = q[k];
      cd.classList.toggle('act', q[k] > 0);
      const minus = cd.querySelector('[data-d="-1"]');
      if (minus) minus.disabled = q[k] <= 0;
      full += q[k] * (+cd.dataset.price || 0);
      if (q[k] > 0 && cd.dataset.name) picked.push((q[k] > 1 ? q[k] + ' × ' : '') + cd.dataset.name);
    });
    const tot = n >= 2 ? Math.round(full * 0.9) : full;
    if (sumEl) sumEl.innerHTML = '<b>' + n + ' lamp' + (n === 1 ? '' : 's') + '</b>' + (picked.length ? ' · ' + picked.join(', ') : '') + (n ? '<span class="bl2"> · ' + n * per + ' bulbs</span>' : '');
    if (offEl) offEl.textContent = n >= 2 ? 'You save ' + money(full - tot) : n === 1 ? 'Add 1 more, save 10%' : 'Pick a ' + (root.dataset.pick || 'color').toLowerCase();
    if (atc) {
      atc.innerHTML = 'Add to cart · ' + money(tot) + (n >= 2 ? ' <s style="opacity:.6;font-weight:400">' + money(full) + '</s>' : '');
      atc.disabled = n === 0;
    }
    if (barB) barB.textContent = money(n ? tot : +(cards[0] && cards[0].dataset.price) || 0);
    if (msg) msg.textContent = '';
  }

  cards.forEach((cd, k) => {
    cd.querySelectorAll('.step button').forEach((bt) => bt.addEventListener('click', () => {
      const d = +bt.dataset.d;
      q[k] = Math.max(0, Math.min(9, q[k] + d));
      upd();
      if (d > 0 && cd.dataset.mid) goMedia(cd.dataset.mid);
    }));
    const im = cd.querySelector('img');
    if (im) im.addEventListener('click', () => cd.dataset.mid && goMedia(cd.dataset.mid));
  });
  upd();

  /* ---- add to cart: every picked variant in one request ---- */
  let busy = false;
  async function add(btn) {
    if (busy) return;
    const items = cards.map((cd, k) => ({ id: Number(cd.dataset.vid), quantity: q[k] })).filter((x) => x.quantity > 0);
    if (!items.length) { if (msg) msg.textContent = 'Pick a ' + (root.dataset.pick || 'color').toLowerCase() + ' first'; return; }
    busy = true;
    [atc, root.querySelector('.bar button')].forEach((b) => b && b.setAttribute('aria-busy', 'true'));
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let ev = null, deferred = null;
    try {
      ev = await import('@shopify/events');
      deferred = ev.CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity })), promise: deferred.promise }));
    } catch (e) { ev = null; }
    try {
      const body = { items };
      if (sectionIds.length) body.sections = sectionIds.join(',');
      const r = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const added = await r.json();
      if (!r.ok) throw new Error((added && (added.description || added.message)) || 'Could not add to cart');
      if (ev && deferred) {
        const cart = await (await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'st-lamp-pdp', sourceId: 'st-lamp-pdp', itemCount: items.reduce((a, b) => a + b.quantity, 0), sections: added.sections, didError: false } });
        setTimeout(() => { if (!document.querySelector('cart-drawer-component, cart-drawer')) window.location.href = base + 'cart'; }, 400);
      } else {
        window.location.href = base + 'cart';
      }
    } catch (err) {
      if (deferred) deferred.reject(err);
      if (msg) msg.textContent = (err && err.message) || 'Could not add to cart. Try again.';
    } finally {
      busy = false;
      [atc, root.querySelector('.bar button')].forEach((b) => b && b.removeAttribute('aria-busy'));
    }
  }
  if (atc) atc.addEventListener('click', () => add(atc));
  const barBtn = root.querySelector('.bar button');
  if (barBtn) barBtn.addEventListener('click', () => add(barBtn));
})();
